module.exports = __webpack_public_path__ + "img/wasser-02.e96181c6.jpg";